/* eslint-disable no-redeclare */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-undef */

export function getDecode(url, downloadToken) {
	url = url.split("?")[0];
	
	let urlAry = url.replace("https://","").split("/"),
	    replaceUrlStr = `https://${urlAry[0]}/${urlAry[1]}/${urlAry[2]}/${urlAry[3]}`,
			filename = url.replace(replaceUrlStr,"");

	let md5CodeAry = [],
			code = "",
			num = 0,
			constants = 64,
			total = 0,
			downloadTokenAry = [],
			decodeTmp = "";

	//算 key 才要 urldecode, 這樣才能支援特殊字元當作檔名
	let filenameUrlDecode = decodeURIComponent(filename);
	let md5Code = md5(filenameUrlDecode);
 	md5CodeAry = md5Code.split("");

	$.each(md5CodeAry,function(i,j){
		if( i % 4 == 0 ){
			code += md5CodeAry[i] + md5CodeAry[i+1] + md5CodeAry[i+2] + md5CodeAry[i+3];
			num += parseInt("0x"+code);
			code = "";
		}
	});

	total = num % constants;
	downloadTokenAry.push(downloadToken.slice(0,total));
	downloadTokenAry.push(downloadToken.slice(total));

	decodeTmp = sha256(downloadTokenAry[0] + filenameUrlDecode + downloadTokenAry[1]);
	return hexStringToByte(decodeTmp);

}

function hexStringToByte(str) {
	if( !str ){
		return new Uint8Array();
	}
	var a = [];
	for (var i = 0, len = str.length; i < len; i+=2) {
		a.push(parseInt(str.substr(i,2),16));
	}
	return new Uint8Array(a);
}


export function xorDecoder(data, decode){
	var xorLoc = 0,
			output = [],
			byteArray = new Uint8Array(data);

	for (var i = 0; i < byteArray.byteLength; i++) {
		output[i] = byteArray[i] ^ decode[xorLoc];
		xorLoc++;
		if (xorLoc >= decode.byteLength){
			xorLoc=0;
		}
	}

	//remove BOM 0xEF(239) 0xBB(187) 0xBF(191)
	if ((output[0] == 239) &&(output[1] == 187) && (output[2] == 191)) {
		output.splice(0,3);
	}
	if(output.length>10000){ //當數組特別長時，為防止內存溢出，進行分割處理，這裡的10000可修改
		var group_num=parseInt(output.length/10000);
		if(output.lenght%10000!=0){
			group_num+=1;
		}

		for(var i=0;i<group_num;i++){
			output[i]=output.slice(i*10000,(i+1)*10000); //轉化成二維數組
		}
		output.splice(group_num,output.length-group_num);  //刪除殘留的一維數組“小尾巴”
		var decode_str="" ;
		for( var i=0;i<output.length;i++){
			// 組裝字符串
			decode_str = decode_str+String.fromCharCode.apply(null, output[i]);
		}
	}else{
	   var decode_str = String.fromCharCode.apply(null, output);
	}
	return Base64._utf8_decode(decode_str);
}


export function isJson(str) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}